module.exports = __webpack_public_path__ + "img/bg-login-1.b6f70d3a.png";